<script>
	import { printdate } from './../../stores/CES.js';
	import { document } from './../../stores/service.js';
  import { modelAnalytics } from './../../Models/analytics/analytics.js';
  import { each, element, mount_component } from "svelte/internal";
  
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { userRol } from "../../stores/user";
  import {
    modalStore,
    dataEdit,
    viewsData,
    addDoc,
    updateD,
    panelController,
    searchDoc,
    dropDoc,
    getInt,
    modalS,
    updateService,
  } from "../../stores/service";

    import 
   MainAnalytics
   from "../../views/admin/analytics/menu/viewanalytics.svelte";

  document.title = "Ratinggs";
  let dataList = [];
  let dataLists = [];
  /*   muestras.subscribe((matriz) => {
    dataList = matriz.map((item) => ({ ...item }));
    
  });

  let fechaFormateada1 = f1;
  let fechaFormateada2 = f2; */

  // Función para manejar el cambio en la fecha seleccionada
  /*   function handleFechaChange(event) {
    fechaFormateada1 = event.target.value;
  }

  function handleFechaChange1(event) {
    fechaFormateada2 = event.target.value;
  }

  function bb() {
    bItems(fechaFormateada1);
  } */
  async function eliminarMuestra(index) {
    /* eliminar */
    $modalS.reset();
    $modalS.info.title = "Aviso";
    $modalS.info.body = `Se va a eliminar a ${$panelController.viewSondeosPanel.ratinggs[index].date.toDate().toLocaleTimeString()}.`;
    $modalS.controllers.btn[0].text = `Si quiero`;
    $modalS.controllers.btn[0].status = true;
    $modalS.controllers.btn[1].text = `No,`;
    $modalS.controllers.btn[1].status = true;
    $modalS.controllers.btnClose = false;
    let modal = await $modalS.mostrar();
    if (modal) {
      $panelController.viewSondeosPanel.ratinggs.splice(index, 1);
      $panelController.viewSondeosPanel.status = true;
      index = await updateD({
        data: {
          ratinggs: $panelController.viewSondeosPanel.ratinggs,
          idMuestra: $panelController.viewSondeosPanel.idMuestra,
        },
        id: $panelController.viewSondeosPanel.id,
        collection: "muestras",
        info: "actualizar",
      });
    }
  }

  onMount(async () => {
    /* if (!$userRol) {
      navigate("/service", { replace: true });
    } */

    if ($panelController.viewSondeosPanel.nav) {
      let datan = await searchDoc({
        collection: "muestras",
        data: [
          "idMuestra",
          "==",
          $panelController.service.listRatinggs[
            $panelController.viewSondeosPanel.index
          ].config.idMuestra,
        ],
      });
      if (datan.status) {
        $panelController.viewSondeosPanel.ratinggs = datan.data[0].doc.ratinggs;
        $panelController.viewSondeosPanel.id = datan.data[0].id;
        $panelController.viewSondeosPanel.idMuestra =
          datan.data[0].doc.idMuestra;
        $panelController.viewSondeosPanel.status = true;
        items = $panelController.viewSondeosPanel.ratinggs;
        /* name(); */
        
      } else {
        navigate("/main-ratinggs", { replace: true });
      }
    }
  });

  function navDash() {
    navigate("/dashboard", { replace: true });
    $panelController.viewDashboard.status = false;
  }

  import { paginate, LightPaginationNav } from "svelte-paginate";
    import Viewanalytics from './analytics/menu/viewanalytics.svelte';

  let items = $panelController.viewSondeosPanel.ratinggs;
  $: items = $panelController.viewSondeosPanel.ratinggs;
  let currentPage = 1;
  let pageSize = 4;

  /*  $:{
    if ( $panelController.viewSondeosPanel.ratinggs > 0) {
      paginatedItems = paginate({ items, pageSize, currentPage })
    }
 } */

 function firebaseLikeId() {
        const chars = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
        let id = '';
        let now = Date.now();

        // parte de tiempo (8 chars)
        for (let i = 7; i >= 0; i--) {
            id = chars[now % 64] + id;
            now = Math.floor(now / 64);
        }
        // parte random (12 chars)
        for (let i = 0; i < 12; i++) {
            id += chars[Math.floor(Math.random() * 64)];
        }
        return id;
    }

function name() {
   let id = firebaseLikeId();
    let setdata = new modelAnalytics();

          const porAnioMes = $panelController.viewSondeosPanel.ratinggs.reduce(
          (acc, ratinggdata) => {
            const date = ratinggdata.date.toDate();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            
            
            if (!acc[year]) acc[year] = [];
            if (!acc[year][month]) acc[year][month] = [];

            acc[year][month].push(ratinggdata);
           
            return acc;
          },
          {},
        );

        let documento = [];


      
        Object.entries(porAnioMes).forEach(([key, property]) => {
         /*  console.log(property);  */
          property.forEach(elementmes => {
            /* console.log(elementmes[0].date.toDate(),elementmes );  */
            const fdate = elementmes[0].date.toDate();
            const pyear = fdate.getFullYear();
            const pmonth = fdate.getMonth() + 1;
            

          setdata.Crear({
              'mes':pmonth.toString(),
              'year':pyear.toString(),
              'data':elementmes,
              id:id
            })
            

            
          });
           
        });
        
}
</script>

{#if $panelController.viewSondeosPanel.status}
  <div class="card text-center">
    <div class="card-header">
      {$panelController.service.listRatinggs[
        $panelController.viewSondeosPanel.index
      ].config.name}
    </div>

    <div class="row">
      <!-- ./col -->
      <div class="col-12" on:click={navDash}>
        <!-- small box -->
        <div class="small-box bg-primary">
          <div class="inner">
            <h3>{$panelController.viewSondeosPanel.ratinggs.length}</h3>
            <p>ratinggs</p>
            <p>ver respuestas</p>
          </div>
          <div class="icon">
            <i class="ion ion-ios-people" />
          </div>
        </div>
      </div>
      <!-- ./col -->
    </div>

    <!-- <div class="row">
  <div class="col-12 col-md-5 col-sm-12 p-1">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <i class="far fa-calendar-alt" />
        </span>
      </div>

      <input
        type="date"
        class="form-control float-right"
        id="reservation"
        bind:value={fechaFormateada1}
        on:change={handleFechaChange}
      />
    </div>
  </div>
  <div class="col-12 col-md-5 col-sm-12 p-1">
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">
          <i class="far fa-calendar-alt" />
        </span>
      </div>
      <input
        type="date"
        class="form-control float-right"
        id="reservation"
        bind:value={fechaFormateada2}
        on:change={handleFechaChange1}
      />
    </div>
  </div>

  <div class="col-12 col-md-2 col-sm-12 p-1">
    <button
      type="button"
      class="btn btn-outline-primary"
      on:click={() => bItems(fechaFormateada1, fechaFormateada2)}>Buscar</button
    >
  </div>
</div> -->

    <table class="table table-sm table align-middle">
      <thead>
        <tr>
          <th scope="col">#</th>
          <!-- <th scope="col">ID</th> -->
          <th scope="col">--</th>
          <th scope="col">Usuario</th>
          <th scope="col">Hora</th>
          <th scope="col">Fecha</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        {#each $panelController.viewSondeosPanel.ratinggs as item, index (item.date)}
          <tr>
            <th scope="row">{index + 1}</th>
            <!-- <td>
        {objeto.id}
      </td> -->

            <!-- const displayName=$user.displayName;
const photoURL = $user.photoURL; -->

            <!-- {#each Object.keys(recuentoPorNumeroDePregunta) as key (key)} -->

            {#if item.user.status}
              <td>
                <div class="user-panel d-flex">
                  <div class="image">
                    <img
                      src={item.user.img}
                      class="img-circle elevation-2"
                      alt="Login"
                    />
                  </div>
                </div>
              </td>
              <td>{item.user.name}</td>
            {:else}
              <td>
                <div class="user-panel d-flex">
                  <div class="image"></div>
                </div>
              </td>
              <td>Anónimo</td>
            {/if}

            <td>{item.date.toDate().toLocaleTimeString()}</td>
            <td>{item.date.toDate().toLocaleDateString()}</td>

            <td>
              <button
                type="button"
                class="btn btn-outline-danger"
                on:click={eliminarMuestra(index)}
                >Eliminar
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

  <!--   <ul class="items">
    {#each paginatedItems as item}
      <li class="item">
        {item}
      </li>
    {/each}
  </ul>
   
  <LightPaginationNav
    totalItems="{items.length}"
    pageSize="{pageSize}"
    currentPage="{currentPage}"
    limit="{1}"
    showStepOptions="{true}"
    on:setPage="{(e) => currentPage = e.detail.page}"
  /> -->
{/if}

<MainAnalytics />
